import React, { useContext } from "react";
import PropTypes from "prop-types";
import Overlay from "../Overlay";
import { FacebookShareButton, LineShareButton } from "react-share";

import { ReactComponent as FacebookSvg } from "../../assets/icons/facebook.svg";
import { ReactComponent as LineSvg } from "../../assets/icons/line.svg";
import { ReactComponent as CopyLinkSvg } from "../../assets/icons/copy-link.svg";
import { toast } from "react-toastify";
import { langComponent } from "../../constants";
import AppContext from "../../AppContext";

const Share = ({ userId, onClose, link, thumbnail }) => {
  const { getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.profile);

  const handleCopyToClipboard = (type) => {
    navigator.clipboard.writeText(link);

    toast.info("Copied profile link to clipboard", {
      autoClose: 2000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    });
  };

  return (
    <Overlay
      style={{ zIndex: 101 }}
      onClose={onClose}
      content={
        <div className="profile-share">
          <h3 className="profile-share__header">{Translation("Share")}</h3>
          <div className="profile-share-list">
            <div
              className="profile-share-list-item"
              onClick={handleCopyToClipboard}
            >
              <div className="profile-share-list-item__border">
                <CopyLinkSvg className="profile-share-list-item__icon profile-share-list-item__icon--small" />
              </div>
              {Translation("Copy Link")}
            </div>
            <FacebookShareButton url={`${link}?picture=${thumbnail}`}>
              <div className="profile-share-list-item">
                <FacebookSvg className="profile-share-list-item__icon" />
                Facebook
              </div>
            </FacebookShareButton>
            <LineShareButton url={link}>
              <div className="profile-share-list-item">
                <LineSvg className="profile-share-list-item__icon" />
                Line
              </div>
            </LineShareButton>
            {/* <WeiboShareButton url={profileLink}>
              <div className="profile-share-list-item">
                <WeiboIcon className="profile-share-list-item__icon" />
                Weibo
              </div>
            </WeiboShareButton>
            <FacebookMessengerShareButton url={profileLink}>
              <div className="profile-share-list-item">
                <FacebookMessengerIcon className="profile-share-list-item__icon" />
                Messenger
              </div>
            </FacebookMessengerShareButton> */}
          </div>
        </div>
      }
    />
  );
};

Share.propTypes = {};

export default Share;
